<template>
  <div class="import-history">
    <div class="import-history__hd">
      <span class="import-history__title">查看历史导入记录</span>
      <span class="import-history__des">(错误数据只保存七天,七天后将自动失效)</span>

      <el-button class="xr-icon-close-btn" icon="el-icon-close" @click="closeClick" />
    </div>

    <el-table :data="tableList" class="import-history__bd" height="250" style="width: 100%">
      <el-table-column prop="create_time" label="导入时间" width="120">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="操作人" width="80" />
      <el-table-column prop="address" label="导入结果">
        <template slot-scope="scope">
          {{ `导入总数据${scope.row.total}条，覆盖${scope.row.cover}条，导入成功${scope.row.total - scope.row.error}条，导入失败${scope.row.error}条。` }}
        </template>
      </el-table-column>
      <el-table-column prop="option" width="150" label="操作">
        <template slot-scope="scope">
          <template v-if="scope.row.total > 0">
            <el-button v-if="scope.row.valid == 1" type="text" @click="downloadError(scope.row.error_data_file_path)">下载错误数据</el-button>
            <span v-else-if="scope.row.valid == 0" class="invalid-tips">已失效</span>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="import-history__ft">
      <el-button type="primary" @click="closeClick">关闭</el-button>
    </div>
  </div>
</template>

<script>
import { systemHistoryActivityListAPI } from "@/api/common";
import { crmDownImportErrorAPI } from "@/api/crm/common";

import { downloadExcelWithResData } from "@/utils/index";

export default {
  // 导入历史
  name: "CRMImportHistory",
  components: {},
  // filters: {
  //   createTime(time) {
  //     const times = time.split(' ')
  //     return times.length > 0 ? times[0] : ''
  //   }
  // },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // CRM类型
    crmType: {
      type: String,
      default: "",
    },
    // moduleType
    props: Object,
  },
  data() {
    return {
      loading: false,
      tableList: [],
    };
  },
  computed: {},
  watch: {
    show(value) {
      if (value) {
        this.getList();
      }
    },
  },
  mounted() {},

  beforeDestroy() {},
  methods: {
    getList() {
      this.loading = true;
      systemHistoryActivityListAPI({
        page: 1,
        limit: 9999,
        type: "crm_" + this.crmType,
        // type: {
        //   customer: 14,
        //   contacts: 16,
        //   leads: 18,
        //   product: 20
        // }[this.crmType] || this.props.moduleType
      })
        .then(res => {
          this.loading = false;
          this.tableList = res.data.list;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 下载错误数据
     */
    downloadError(path) {
      crmDownImportErrorAPI({ path, name: "导入错误数据" })
        .then(res => {
          downloadExcelWithResData(res);
        })
        .catch(() => {});
    },

    getImportContent(totalSize, content) {
      // const list = content.split(',') || []
      // const updateSize = Number(list[1] || '0')
      // const errSize = Number(list[0] || '0')
      // return `覆盖${updateSize}条，导入成功${totalSize - errSize}条，导入失败${errSize}条。`
    },

    /**
     * 获取错误数据数
     */
    getErrorNum(content) {
      const list = content.split(",") || [];
      const errSize = Number(list[0] || "0");
      return parseInt(errSize);
    },

    /**
     * 关闭
     */
    closeClick() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .import-history {
    width: 94.6667vw;
    margin: 0 !important;
    .import-history__hd {
      padding: 4vw 2.6667vw 1.3333vw !important;
      position: relative;
      .xr-icon-close-btn {
        position: absolute;
        top: 1.3333vw;
        right: 1.3333vw;
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .import-history {
    width: 800px;
  }
}
.import-history {
  &__hd {
    padding: 20px;
    padding-bottom: 10px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  &__des {
    font-size: 12px;
    color: #ccc;
  }

  &__bd {
    border-top: 1px solid #e6e6e6;
  }

  &__ft {
    padding: 10px;
    background-color: #f7f8fa;

    text-align: right;
  }

  .xr-icon-close-btn {
    float: right;
  }
}

.invalid-tips {
  color: #999;
}
</style>
